type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    id?: string | number;
};

export function SmileyIcon({ width = 12, height = 12, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            className={className}
            style={style}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 6C11 8.7614 8.7614 11 6 11C3.23857 11 1 8.7614 1 6C1 3.23857 3.23857 1 6 1C8.7614 1 11 3.23857 11 6ZM5.375 5C5.375 5.48325 4.98325 5.875 4.5 5.875C4.01675 5.875 3.625 5.48325 3.625 5C3.625 4.51675 4.01675 4.125 4.5 4.125C4.98325 4.125 5.375 4.51675 5.375 5ZM7.5 5.875C7.98325 5.875 8.375 5.48325 8.375 5C8.375 4.51675 7.98325 4.125 7.5 4.125C7.01675 4.125 6.625 4.51675 6.625 5C6.625 5.48325 7.01675 5.875 7.5 5.875ZM4.12889 7.25C4.41574 7.058 4.80038 7.1491 5.08555 7.3436C5.34625 7.52145 5.6611 7.625 6 7.625C6.3389 7.625 6.65375 7.52145 6.91445 7.3436C7.1996 7.1491 7.58425 7.058 7.8711 7.25C8.15795 7.442 8.2386 7.8366 7.98945 8.07545C7.4734 8.5701 6.7724 8.875 6 8.875C5.2276 8.875 4.52659 8.5701 4.01057 8.07545C3.76139 7.8366 3.84205 7.442 4.12889 7.25Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SmileyIcon;
